<template>
  <div>
    <TheHeader></TheHeader>
    <BreadcrumbBar/>
    <PageHeader>
      <TextHeading variant="subtitle" color="secondary">Progress against our nine key focus areas</TextHeading>
      <TextHeading variant="lg">Our ten key focus areas</TextHeading>
    </PageHeader>
    <PageGrid sidebar>
      <PageSide>
        <SideNav/>
        <CardDownload title="Corporate Responsibility 2018/2019" shape="rectangle"/>
      </PageSide>
      <PageMain>
        <!-- Key Area 01 -->
        <div class="key-focus-areas">
          <CardReportHeader class="key-focus-areas__header" image="cr/wonky-chilli.png">
            <TextHeading variant="subtitle" color="secondary">1. Increasing global demand</TextHeading>
            <TextHeading variant="lg" block>Sourcing Responsibly</TextHeading>
          </CardReportHeader>
          <div class="key-focus-areas__wrapper">
            <CardReportBlocks
              quantity="£330,000"
              details="Donated to food redistribution charities
(2017/18: £250,000)"
            ></CardReportBlocks>
            <CardReportBlocks quantity="5.1m" details="Total unsold food products donated"/>
            <CardReportBlocks
              gradient
              details="Over 250 farmers supported through Naturally Wonky range"
            />
            <CardReportBlocks
              gradient
              details="Over 2,000,000 meals donated to FareShare through our manufacturing sites since 2017"
            />
          </div>
        </div>
        <!-- Key Area 02 -->
        <div class="key-focus-areas">
          <CardReportHeader class="key-focus-areas__header" image="cr/fish.png">
            <TextHeading variant="subtitle" color="secondary">2. Source responsibly</TextHeading>
            <TextHeading variant="lg" block>Ensuring supply chains remain sustainable</TextHeading>
          </CardReportHeader>
          <div class="key-focus-areas__wrapper">
            <CardReportBlocks
              gradient
              details="Supporting members of Global Ghost Gear fishing initiative"
            ></CardReportBlocks>
            <CardReportBlocks
              quantity="87%"
              details="FSC, approved alternative or recycled own brand household and beauty products"
            />
            <CardReportBlocks
              gradient
              details="Continued participation in Sustainable Fisheries Ocean Disclosure Project"
            />
          </div>
        </div>
        <!-- Key Area 03 -->
        <div class="key-focus-areas">
          <CardReportHeader class="key-focus-areas__header" image="cr/bag-group-shot.png">
            <TextHeading variant="subtitle" color="secondary">3. Changing our use of plastic</TextHeading>
            <TextHeading variant="lg" block>Recyclable, reusable or compostable</TextHeading>
          </CardReportHeader>
          <div class="key-focus-areas__wrapper">
            <CardReportBlocks quantity="174m" details="Plastic produce bags removed"></CardReportBlocks>
            <CardReportBlocks
              quantity="9,000"
              details="Tonnes of plastic removed or made widely recyclable"
            />
            <CardReportBlocks
              quantity="600"
              details="Tonnes of unrecyclable polystyrene removed from Morrisons branded products"
            />
            <CardReportBlocks
              quantity="81%"
              details="Morrisons branded plastic packaging is recyclable by weight"
            />
          </div>
        </div>
        <!-- Key Area 04 -->
        <div class="key-focus-areas">
          <CardReportHeader class="key-focus-areas__header" image="cr/chicken.png">
            <TextHeading variant="subtitle" color="secondary">4. Changing our use of plastic</TextHeading>
            <TextHeading variant="lg" block>Supporting British farmers</TextHeading>
          </CardReportHeader>
          <div class="key-focus-areas__wrapper">
            <CardReportBlocks quantity="100%" details="British own brand fresh meat, milk and eggs"></CardReportBlocks>
            <CardReportBlocks
              quantity="£12m"
              details="Donated to farmers through For Farmers range 
(2017/18 £9m raised)"
            />
            <CardReportBlocks
              gradient
              details="All own brand fresh shell eggs will be cage free by 2022"
            />
            <CardReportBlocks
              gradient
              details="Retailer of the Year at the Food and Farming Awards"
            />
          </div>
        </div>
        <!-- Key Area 05 -->
        <div class="key-focus-areas">
          <CardReportHeader class="key-focus-areas__header" image="cr/light-bulb.png">
            <TextHeading variant="subtitle" color="secondary">5. Reducing operational waste</TextHeading>
            <TextHeading variant="lg" block>General waste and carbon emissions</TextHeading>
          </CardReportHeader>
          <div class="key-focus-areas__wrapper">
            <CardReportBlocks quantity="99.5%" details="Store waste recycled or reprocessed"></CardReportBlocks>
            <CardReportBlocks quantity="45% " details="Reduction in operational carbon emissions"/>
            <CardReportBlocks gradient details="Voltage optimisation and LED lighting rollout"/>
            <CardReportBlocks gradient details="Continued rollout of CO2 refridgeration"/>
          </div>
        </div>
        <!-- Key Area 06 -->
        <div class="key-focus-areas">
          <CardReportHeader class="key-focus-areas__header" image="cr/sponge.png">
            <TextHeading variant="subtitle" color="secondary">6. Our supply chain</TextHeading>
            <TextHeading variant="lg" block>Ensuring fair working conditions for workers</TextHeading>
          </CardReportHeader>
          <div class="key-focus-areas__wrapper">
            <CardReportBlocks
              quantity="870"
              details="Colleagues trained on modern slavery
(2017/18: 537 colleagues trained)"
            ></CardReportBlocks>
            <CardReportBlocks gradient details="Supported Responsible Car Wash scheme launched"/>
            <CardReportBlocks gradient details="Publication of Nutmeg tier one factory list"/>
          </div>
        </div>
        <!-- Key Area 07 -->
        <div class="key-focus-areas">
          <CardReportHeader class="key-focus-areas__header" image="cr/v-taste.png">
            <TextHeading variant="subtitle" color="secondary">7. Make it easy</TextHeading>
            <TextHeading variant="lg" block>For our customers to live healthier lives</TextHeading>
          </CardReportHeader>
          <div class="key-focus-areas__wrapper">
            <CardReportBlocks
              quantity="613"
              details="Tonnes of sugar removed from Morrisons branded products"
            ></CardReportBlocks>
            <CardReportBlocks
              quantity="2.45bn"
              details="Calories removed from Morrisons branded products"
            ></CardReportBlocks>
            <CardReportBlocks gradient details="V Taste vegan range launched"/>
            <CardReportBlocks gradient details="Little Kitchen range launched"/>
          </div>
        </div>
        <!-- Key Area 08 -->
        <div class="key-focus-areas">
          <CardReportHeader class="key-focus-areas__header" image="cr/clic-sargent.png">
            <TextHeading variant="subtitle" color="secondary">8. Making a difference</TextHeading>
            <TextHeading variant="lg" block>Positively affecting the communities we serve</TextHeading>
          </CardReportHeader>
          <div class="key-focus-areas__wrapper">
            <CardReportBlocks
              quantity="£5.5m"
              details="Donated to charities through Morrisons Foundation"
            ></CardReportBlocks>
            <CardReportBlocks
              quantity="£3.6m"
              details="Raised for charity partner CLIC Sargent (2017/18: £3.4m)"
            ></CardReportBlocks>
            <CardReportBlocks gradient details="Quieter hour launched"/>
            <CardReportBlocks
              gradient
              details="Defibrillator rollout in stores and sites complete"
            />
          </div>
        </div>
        <!-- Key Area 09 -->
        <div class="key-focus-areas">
          <CardReportHeader class="key-focus-areas__header" image="cr/nuts.png">
            <TextHeading variant="subtitle" color="secondary">9. Reducing Risks</TextHeading>
            <TextHeading variant="lg" block>Ensuring food safety, quality and provenance</TextHeading>
          </CardReportHeader>
          <div class="key-focus-areas__wrapper">
            <CardReportBlocks
              quantity="4th"
              details="Year below FSA’s retailer target on campylobacter levels"
            ></CardReportBlocks>
            <CardReportBlocks
              quantity="3rd"
              details="Year of Culture of Excellence programme in manufacturing"
            ></CardReportBlocks>
            <CardReportBlocks
              gradient
              details="All labels on our pre-packed in-store products carry allergens advice"
            />
            <CardReportBlocks
              gradient
              details="All Morrisons branded fresh meat can be traced back to farm"
            />
          </div>
        </div>
        <!-- Key Area 10 -->
        <div class="key-focus-areas">
          <CardReportHeader class="key-focus-areas__header" image="cr/colleagues.png">
            <TextHeading variant="subtitle" color="secondary">10. Ensuring Success</TextHeading>
            <TextHeading variant="lg" block>Looking after our colleagues</TextHeading>
          </CardReportHeader>
          <div class="key-focus-areas__wrapper">
            <CardReportBlocks quantity="76%" details="Colleague engagement score"></CardReportBlocks>
            <CardReportBlocks quantity="500" details="Fresh food apprenticeships launched"></CardReportBlocks>
            <CardReportBlocks
              gradient
              details="My Performance plans launched to support colleague development"
            />
            <CardReportBlocks gradient details="Colleague wellbeing toolkits launched"/>
          </div>
        </div>
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import PageMain from '../elements/PageMain.vue'
import TheFooter from '../components/TheFooter.vue'
import CardReportBlocks from '../components/CardReportBlocks.vue'
import CardReportHeader from '../components/CardReportHeader.vue'
import CardDownload from '../components/CardDownload.vue'
import SideNav from '../components/SideNav.vue'
import PageSide from '../elements/PageSide.vue'
import PageGrid from '../elements/PageGrid.vue'
import TextHeading from '../elements/TextHeading.vue'
import PageHeader from '../components/PageHeader.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'
export default {
  name: 'CRFocusAreas',
  components: {
    TheHeader,
    BreadcrumbBar,
    PageHeader,
    TextHeading,
    PageGrid,
    PageSide,
    SideNav,
    CardDownload,
    CardReportHeader,
    CardReportBlocks,
    TheFooter,
    PageMain
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>
<style lang="postcss">
.key-focus-areas {
  @apply flex flex-wrap mt-8 mb-6;
}
.key-focus-areas__header {
  @apply w-full;
}
.key-focus-areas__wrapper {
  @apply flex justify-start items-stretch -mt-16 -mx-6 overflow-scroll scrolling-touch;
}
@screen md {
  .key-focus-areas__wrapper {
    @apply flex-wrap justify-center mx-0 overflow-visible mb-8;
  }
}
@screen lg {
  .key-focus-areas {
    @apply pl-8 -ml-2/12 mt-0 mb-8;
  }
  .key-focus-areas__wrapper {
    @apply -mx-4;
    width: calc(100% + 2rem);
  }
}
</style>

